import { Pcr } from '../../lib/types/models/pcr/pcr'
import { StaffApplicationMarkAsPaidInput } from '../../lib/types/models/staff-application/staff-application-input'
import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function markStaffApplicationsAsPaid(data: IdsInput<StaffApplicationMarkAsPaidInput>) {
  return restApiClient
    .url(constructApiUrl(API.candidate.markAsPaid.url, null))
    .post<Pcr, IdsInput<StaffApplicationMarkAsPaidInput>>(data)
}
